import { Component, Input } from '@angular/core';

@Component({
  selector: 'no-data-label',
  templateUrl: './no-data-label.component.html',
  styleUrls: ['./no-data-label.component.scss']
})
export class NoDataLabelComponent {

  @Input() color = '#47535E';
  @Input() fontSize = '16px';

}
